import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router';
import { useGoogleReCaptcha } from '@google-recaptcha/react';
import { Notify } from 'notiflix/build/notiflix-notify-aio';

import appSelectors from '@/redux/app/appSelectors';
import feedbackSelectors from '@/redux/feedback/feedbackSelectors';

import feedbackOperations from '@/redux/feedback/feedbackOperations';

import useMatchMedia from '@/hooks/useMatchMedia';
import RouteNames from '@/router/routes';

import Container from '@/components/container';
import Rubricator from '@/components/rubricator';
import Input from '@/ui/input';

import ModalSuccess from './modalSuccess';

import s from './feedback.module.css';

function Feedback() {
  const dispatch = useDispatch();

  const i18n = useSelector(appSelectors.translation);
  const status = useSelector(feedbackSelectors.status);

  const { pathname } = useLocation();
  const { executeV3 } = useGoogleReCaptcha();
  const { isDesktop } = useMatchMedia();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [telegram, setTelegram] = useState('');

  const [displayModal, setDisplayModal] = useState(false);
  const toggleModal = () => setDisplayModal(!displayModal);

  const [recaptchaToken, setRecaptchaToken] = useState('');
  console.log('Recaptcha token:', recaptchaToken);

  // Create an event handler so you can call the verification on button click event or form submit
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeV3) {
      console.log('Execute recaptcha not available');
      return;
    }

    const token = await executeV3();

    setRecaptchaToken(token);
  }, [executeV3]);

  const handleSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    if (!recaptchaToken) {
      Notify.warning('Google recaptcha is required');
      return;
    }

    if (!name) {
      Notify.warning(i18n.Введите_ваше_имя);
      return;
    }

    if (!email) {
      Notify.warning(i18n.Введите_ваш_email);
      return;
    }

    const data = {
      name,
      email,
      telegram: telegram || null,
      page: pathname,
    };

    dispatch(feedbackOperations.requestFeeback(data));
  };

  // You can use useEffect to trigger the verification as soon as the component being loaded
  useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify]);

  useEffect(() => {
    if (status === 'success') {
      toggleModal();

      setName('');
      setEmail('');
      setTelegram('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return (
    <>
      <section className={s.section}>
        <Container>
          <div className={s.block}>
            <Rubricator
              single={isDesktop ? i18n.форма_обратной_связи : i18n.форма_связи}
            />
            <div className={s.wrapper}>
              <p className={s.title}>{i18n.Остались_вопросы}?</p>
              <p className={s.text}>{i18n.Оставьте_свои_данные}</p>
              <form onSubmit={handleSubmit} className={s.form}>
                <Input
                  id="resaleInputName"
                  placeholder={i18n.имя}
                  value={name}
                  onChange={setName}
                />
                <Input
                  type="email"
                  id="resaleInputEmail"
                  placeholder="e-mail"
                  value={email}
                  onChange={setEmail}
                />
                <Input
                  id="resaleInputTelegram"
                  placeholder={i18n.telegram_необязательно}
                  value={telegram}
                  onChange={setTelegram}
                />
                <button type="submit" className={s.btn_ok}>
                  {i18n.отправить}
                </button>
              </form>

              <p className={s.disclaimer}>
                {i18n.При_нажатии_на_кнопку}{' '}
                <Link to={`/${RouteNames.PRIVACY_POLICY}`}>
                  {i18n.политикой_конфиденциальности}
                </Link>
              </p>
            </div>
          </div>
        </Container>
      </section>

      {displayModal && <ModalSuccess close={toggleModal} />}
    </>
  );
}

export default Feedback;
